module.exports = __webpack_public_path__ + "img/part4-uIcon22.ce94e1ab.png";